module.exports = __webpack_public_path__ + "img/2.2c57edc7.png";